import { useEffect } from 'react';

const MIN_MS = 900;
const FADE_MS = 450;

export function PageLoader() {
  useEffect(() => {
    const boot = document.getElementById('boot-loader');
    const started = performance.now();
    let fadeTimer;
    let removeTimer;
    let cancelled = false;
    let finished = false;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const restoreOverflow = () => {
      document.body.style.overflow = previousOverflow;
    };

    const finish = () => {
      if (cancelled || finished) return;
      finished = true;

      const wait = Math.max(0, MIN_MS - (performance.now() - started));

      fadeTimer = window.setTimeout(() => {
        if (cancelled) return;

        boot?.classList.add('is-leaving');
        document.documentElement.classList.remove('booting');
        restoreOverflow();

        removeTimer = window.setTimeout(() => {
          boot?.remove();
        }, FADE_MS);
      }, wait);
    };

    if (document.readyState === 'complete') {
      finish();
    } else {
      window.addEventListener('load', finish, { once: true });
    }

    const safety = window.setTimeout(finish, 4000);

    return () => {
      cancelled = true;
      window.clearTimeout(fadeTimer);
      window.clearTimeout(removeTimer);
      window.clearTimeout(safety);
      window.removeEventListener('load', finish);
      restoreOverflow();
      document.documentElement.classList.remove('booting');
    };
  }, []);

  return null;
}
